import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './header.component';

import { HeaderService } from '../../services/header/header.service';
import { CapitalizePipe } from '../../pipes/capitalize/capitalize.pipe';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    RouterModule
  ],
  exports: [
    HeaderComponent
  ],
  declarations: [
    HeaderComponent,
    CapitalizePipe
  ]
})

export class HeaderModule  {
  static forRoot() {
    return {
      ngModule: HeaderModule,
      providers: [ HeaderService ]
    }
  }
}
